import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";

import ThemeSource from "./Theme/ThemeSource";
import { ThemeProvider } from "styled-components";
import {
  MuiThemeProvider,
  StylesProvider,
  unstable_createMuiStrictModeTheme as createMuiTheme,
} from "@material-ui/core/styles";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <StylesProvider injectFirst> </StylesProvider>
      <MuiThemeProvider theme={createMuiTheme(ThemeSource)}>
        <ThemeProvider theme={ThemeSource}>
          <App />
        </ThemeProvider>
      </MuiThemeProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
